import React, { Component } from 'react'
import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import Page from '../containers/Page'
import { simple_api_request } from '../api/simple_api_request'
import PropTypes from 'prop-types'
import { PropTypes as MobxPropTypes } from 'mobx-react/index'

@observer
class NotVerifiedPage extends Component {
  @observable success = false
  @action set_success = () => this.success = true

  @observable error = false
  @action set_error = (error) => this.error = error

  confirmEmail = () => {
    const { email } = this.props
    const { set_success, set_error } = this

    simple_api_request({
      method: 'GET',
      path: '/api/register/' + email + '/confirm'
    })
      .then(result => {
        console.log('VerifiedAccountHandler.js - request - result:', result)

        if (!result.ok ) {
          console.log('!result.ok')
          set_error(result.data.message)
        }

        if (result.data.success) {
          set_success()
        }

        return result.data
      })
      .catch(error => {
        set_error(error)
        console.log('VerifiedAccountHandler.js - request - error:', error)
      })
  }

  render () {
    const { success, error } = this

    if (error) {
      return (
        <Page title='Error'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <code>{this.error.toString()}</code>
          </article>
        </Page>
      )
    }

    if (success) {
      return (
        <Page title='Confirmation sent'>
          <article className='b-info'>
            <h2 className='b-info-title'>New confirmation email has been sent</h2>
          </article>
        </Page>
      )
    }

    return (
      <Page title='Account not verified'>
        <article className='b-info'>
          <h2 className='b-info-title'>Account not verified</h2>
          <p>You haven’t verified your e-mail adress yet.</p>
          <p>To create an Experience or book one, please verify that your e-mail address is valid.</p>
          <button className='b-link'
                  type='button'
                  onClick={this.confirmEmail}>
            Resend verification e-mail
          </button>
        </article>
      </Page>
    )
  }
}

NotVerifiedPage.propTypes = {
  email: PropTypes.string
}

export default NotVerifiedPage



// WEBPACK FOOTER //
// ./src/containers/NotVerifiedPage.js